import $ from "jquery";
import { vuwer } from "@@assets/scripts/common";
import "@@assets/klass/VuwSlider";

vuwer.get("pageHeader").add("slider", {
	vuwType: "slider",
	
	slickOptions: {
		fade: true,
		autoplaySpeed: 2500,
		speed: 800
	},
	
	selector() {
		return this.container.$self.children(".vuw-slider");
	},
	
	onReady($self) {
		$self.find("img").each((i, img) => {
			$(img).addClass("hide").parent().css({
				"background-image": `url("${img.src}")`
			});
		});
	},
});
